
import Select from 'react-select'
import ASelect from '@atlaskit/select'
import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useSelector } from 'react-redux'
import { AiOutlineDown, AiOutlineInbox } from 'react-icons/ai'
import Creatable from 'react-select/creatable'
import { Drawer, Dropdown, Menu, Tabs, Upload } from 'antd'

import { usePet, useToggle, useListData, notifOps } from '../../modules'
import { buildFormFieldPayload } from '../../formDataSources'

import Confirm from '../reusable/confirm'

import FormFields from './formFields'

const { TabPane } = Tabs

const { Dragger } = Upload

const NewInputForm = ({ toggle, visible, categories, onPerform }) => {
    const [cat, setCat] = useState()
    const [name, setName] = useState()
    const [index, setIndex] = useState()
    const [file, setFile] = useState([])
    const [border, setBorder] = useState('10')
    const [format, setFormat] = useState({ label: 'A4', value: 'A4' })
    const [catgs, setCatgs] = useState([])
    const [fields, setFields] = useState([])
    const [string, setString] = useState('')
    const [selected, setSelected] = useState()
    const [category, setCategory] = useState()
    const [saleItems, setSaleItems] = useState([])
    const [cats, setCats] = useState([...categories])
    const [orientation, setOrientation] = useState({ label: 'Portrait', value: 'portrait' })

    const [field, toggleField] = useToggle()

    const { enqueueSnackbar } = useSnackbar()
    const { params } = useSelector(state => state.application)

    let formats = ['A4', 'A3', 'A2', 'Legal', 'Letter', 'Tabloid']
    let orientations = [
        { label: 'Portrait', value: 'portrait' },
        { label: 'Landscape', value: 'landscape' },
    ]

    const close = () => {
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Input form has been created', ops('success'))

        setTimeout(close, 300)
    }

    const editField = i => {
        setSelected(fields[i])
        setIndex(i)
        toggleField()
    }

    const [
        { loading: iLoading, fetch: fetchItems },
        { list: items }
    ] = useListData('saleItems', { string, routingGroup: cat?.label }, { notify: true }, 'items')

    usePet('routingGroupNames', { hidden: false }, { notify: true, callback: ({ data }) => setCatgs(data) })

    const [{ loading }, execute] = usePet('newInputForm', {
        name,
        category: category?.value,
        fields: fields.map(buildFormFieldPayload),
        format: format?.value,
        orientation: orientation?.value,
        border,
        template: file[0]?.originFileObj,
        saleItems: saleItems.map(si => si.value)
    }, { notify: true, hasFile: true, callback: onComplete, manual: true })
    
    const props = {
        name: 'template',
        fileList: file,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange: info => {
            let { fileList } = info
            fileList = fileList.slice(-1)
            let temp = fileList[0]

            let [, ext] = temp?.name.split('.')
            const isOK = ext.toLowerCase() === 'hbs'
            if (!isOK) {
                enqueueSnackbar('Please upload a handlebars file', notifOps('warning'))
                return false
            }
    
            let isLarge = (temp?.size / 1024 / 1024) > params?.maxFileUploadSize
            if (isLarge)
                enqueueSnackbar(`Please upload a file smaller than ${params?.maxFileUploadSize} MB`, notifOps('warning'))
            
            if (isOK && !isLarge)
                setFile(fileList)
        },
        beforeUpload: () => false,
        onDrop: (e) => {
            console.log('Dropped files', e.dataTransfer.files);
        },
    }

    const onCategoryChange = ct => {
        setCat(ct)
        fetchItems()
    }

    const search = str => {
        if (str?.trim()?.length >= 1 || !str) {
            setString(str)
            fetchItems()
        }
    }

    const onSave = ({ field, i }) => {
        setFields(val => {
            if (i >= 0)
                val[i] = field
            else
                val = [...val, field]

            return val
        })
    }

    const clearSelected = () => {
        setSelected()
        setIndex()
    }

    const remove = index => {
        clearSelected()
        setFields(val => val.filter((_, i) => i !== index))
    }

    const newField = () => {
        clearSelected()
        toggleField()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={loading} onClick={() => Confirm({
                        title: 'Create Input Form',
                        message: 'Are you sure you want to create this input form?',
                        onOk: execute,
                        okText: 'Proceed',
                    })} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Input Form</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">New Input Form</p>
            <Tabs>
                <TabPane key="0" tab="Details">
                    <div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full px-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Form Name
                                </label>
                                <input
                                    onChange={e => setName(e.target.value)}
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-role-name"
                                    type="text"
                                    value={name}
                                    name="name"
                                    placeholder="Daily Visits" />
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full px-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Form Category
                                </label>
                                <Creatable
                                    value={category}
                                    onCreateOption={val => {
                                        setCats([...cats, val])
                                        setCategory({ label: val, value: val })
                                    }}
                                    onChange={setCategory}
                                    options={cats.map(cat => ({ label: cat, value: cat }))}
                                    placeholder="Select Category" />
                            </div>
                        </div>
                    </div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mt-3" htmlFor="grid-name">Fields</label>
                    <div className="flex items-center justify-between">
                        {
                            fields?.length > 0 ?
                                <>
                                    <table className="table-auto w-full">
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Type</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                fields.map((fld, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{fld.name}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{fld.type?.label}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div>
                                                                <Dropdown
                                                                    overlay={
                                                                        <Menu>
                                                                            <Menu.Item onClick={() => editField(key)}>View</Menu.Item>
                                                                            <Menu.Item onClick={() => remove(key)}>Remove</Menu.Item>
                                                                        </Menu>
                                                                    }>
                                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                </Dropdown>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </>
                                :
                                // <div className="w-full h-12 text-center">
                                <p className="font-semibold w-full text-center mt-4">Please click below to add new fields</p>
                            // </div>
                        }
                    </div>
                    <div className="w-full h-16 text-center">
                        <button onClick={newField} className="btn py-2 px-3 mt-0 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Field</button>
                    </div>
                </TabPane>
                <TabPane key="1" tab="Printout">
                    <div className="rounded border border-blue-200 bg-blue-50 px-4 py-3 mb-4 text-sm text-blue-900">
                        Structured result capture works even if you skip a custom print template. If you leave the upload empty, the system will use the default print layout and you can customise the printout later.
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Format
                            </label>
                            <Select
                                value={format}
                                onChange={setFormat}
                                options={formats.map(fm => ({ label: fm, value: fm }))}
                                placeholder="Select Format" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Orientation
                            </label>
                            <Select
                                value={orientation}
                                onChange={setOrientation}
                                options={orientations}
                                placeholder="Select Orientation" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Border
                            </label>
                            <input
                                onChange={e => setBorder(e.target.value)}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-border"
                                type="number"
                                value={border}
                                name="border"
                                placeholder="Border Width in mm" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Template File <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                            </label>
                            <p className="text-xs text-gray-500 mb-2">Optional. Leave blank if you only need structured capture for day-one operations.</p>
                            <Dragger {...props}>
                                <p className="ant-upload-drag-icon flex justify-center">
                                    <AiOutlineInbox size={40} />
                                </p>
                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                <p className="ant-upload-hint">If provided, upload a Handlebars (.hbs) file for the printed layout. Otherwise the default print layout will be used.</p>
                            </Dragger>
                        </div>
                    </div>
                </TabPane>
                <TabPane key="2" tab="Sale Items">
                    <div className="min-w-full my-1 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Department Queue
                        </label>
                        <p className="text-gray-500 text-xs italic mb-1">Filters items by the department queue they route to after billing.</p>
                        <div className="flex items-center justify-between min-w-full">
                            <ASelect
                                inputId="single-select-example"
                                className="single-select w-60"
                                classNamePrefix="react-select"
                                onChange={onCategoryChange}
                                value={cat}
                                options={catgs.map(cat => ({ label: cat, value: cat }))}
                                placeholder="Choose Category" />
                        </div>
                    </div>
                    <div className="w-full mt-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Select Items
                        </label>
                        <Select
                            isMulti
                            onInputChange={search}
                            onChange={setSaleItems}
                            isLoading={iLoading}
                            value={saleItems}
                            options={items?.map(itm => ({ label: itm.name, value: itm._id }))}
                            placeholder="Select Items" />
                    </div>
                </TabPane>
            </Tabs>
            {
                field &&
                <FormFields
                    index={index}
                    onSave={onSave}
                    visible={field}
                    field={selected}
                    toggle={toggleField} />
            }
        </Drawer>
    )
}

export default NewInputForm
